import { ref, computed } from 'vue'
import useEventEmitter from '@/_core/hooks/useEventEmitter'
import useApiRequest from '@/_core/hooks/useApiRequest'
import { setFavorite } from '@/services/catalog'

export default function SetFavoriteController () {
  const { $on, $off, $emit } = useEventEmitter()

  const targetItem = ref(null)

  const bookmarkRequest = useApiRequest(setFavorite)
  bookmarkRequest.$on('success', () => {
    if (bookmarkRequest.data?.status === 'success') {
      _refreshItemBookmark()
    }
    $emit('requestSetFavorite-success', bookmarkRequest.data)
  })
  bookmarkRequest.$on('error', () => {
    $emit('requestSetFavorite-error', bookmarkRequest.errors)
  })
  const request = async (userItem, value = true) => {
    targetItem.value = userItem
    const data = {
      type: userItem.type,
      id: userItem.id,
      flag: value
    }
    await bookmarkRequest.request(data)
  }

  const _refreshItemBookmark = () => {
    if (targetItem.value) {
      targetItem.value.favorite = !targetItem.value.favorite
    }
    targetItem.value = null
  }

  // Output.
  return {
    request,
    isLoading: computed(() => bookmarkRequest.isLoading),
    $on,
    $off
  }
}
